import { Box, Typography } from '@mui/material'
import type React from 'react'

interface Props {
  comments: string[]
}

const DecisionComments: React.FC<Props> = ({ comments }) => {
  if (!comments.length) return null

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600}>
        Decision comment
      </Typography>
      <Box sx={{ mt: 1.5 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'pre-wrap' }}
        >
          {comments.join('\n\n')}
        </Typography>
      </Box>
    </Box>
  )
}

export default DecisionComments
